<template>
  <v-dialog
    v-model="show"
    max-width="90%"
  >
    <v-card>
      <v-card-title>
        {{ allEmployeeMode ? 'All Employee ' : rowItem.Full_Name + "'s" }} Requests
        <v-spacer></v-spacer>
        <v-select
          v-model="groupBy"
          dense
          hide-details
          label="Group by"
          item-text="title"
          item-value="value"
          multiple
          :items="groupByItems"
          clearable
          return-object
          @click:clear="groupBy = null"
        ></v-select>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs
          v-model="currentTabIndex"
          show-arrows
          centered
          @change="openHistory"
        >
          <v-tab
            v-for="(title, key) in tabTitles"
            :key="key"
          >
            <span>{{ title.groupName }}</span>
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items
          v-model="currentTabIndex"
          style="max-height: 620px; min-height: 400px; overflow: auto;"
        >
            <ExpenditureCompensationHistory
              v-if="requestModels.expenditureHistory"
              v-model="requestModels.expenditureHistory"
              :employeeId="rowItem?.Employee_ID"
              :showListEmployee="allEmployeeMode"
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :groupBy="groupBy"
              :fromRequestModule="true"
              :filterBySubcategory="filterBySubcategory"
              @actionOnRequest="requestWasChanged('Benefit', $event)"
            />
            <LAndDRequestHistory
              v-if="requestModels.lAndDHistory"
              v-model="requestModels.lAndDHistory"
              :employeeId="rowItem?.Employee_ID"
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :groupBy="groupBy"
              :fromRequestModule="true"
              :showListEmployee="allEmployeeMode"
              @actionOnRequest="requestWasChanged('L&D', $event)"
            />
            <BonusRequestHistory
              v-if="requestModels.bonusHistory"
              v-model="requestModels.bonusHistory"
              :employeeId="rowItem?.Employee_ID"
              :fromRequestModule=true
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :groupBy="groupBy"
              :showListEmployee="allEmployeeMode"
            />
            <AbsenceRequestHistory
              v-if="requestModels.sickLeaveHistory"
              v-model="requestModels.sickLeaveHistory"
              :employeeId="rowItem?.Employee_ID"
              :fromRequestModule=true
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :groupBy="groupBy"
              :showListEmployee="allEmployeeMode"
              @actionOnRequest="requestWasChanged('Sick Leave', $event)"
            />
            <SportCompensationRequestHistory
              v-if="requestModels.sportCompensationHistory"
              v-model="requestModels.sportCompensationHistory"
              :employeeId="rowItem?.Employee_ID"
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :fromRequestModule=true
              :groupBy="groupBy"
              :showListEmployee="allEmployeeMode"
              @actionOnRequest="requestWasChanged('Sport', $event)"
            />
            <MedicalInsuranceRequestHistory
              v-if="requestModels.medicalInsuranceHistory"
              v-model="requestModels.medicalInsuranceHistory"
              :employeeId="rowItem?.Employee_ID"
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :fromRequestModule=true
              :groupBy="groupBy"
              :showListEmployee="allEmployeeMode"
              @actionOnRequest="requestWasChanged('Medical Insurance', $event)"
            />
            <RefundRequestHistory
              v-if="requestModels.refundHistory"
              v-model="requestModels.refundHistory"
              :employeeId="rowItem?.Employee_ID"
              :dateFrom="requestsInterval[0]"
              :dateTo="requestsInterval[1]"
              :fromRequestModule="true"
              :groupBy="groupBy"
              :showListEmployee="allEmployeeMode"
              @actionOnRequest="requestWasChanged('Refund', $event)"
            />
            <EquipmentReplacementRequestHistory
              v-if="requestModels.equipmentReplacementHistory"
              v-model="requestModels.equipmentReplacementHistory"
              :employeeId="rowItem?.Employee_ID"
              :fromRequestModule="true"
            />
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RequestMenu',
  components: {
    SportCompensationRequestHistory: () => import('@/components/employee/employee_requests/SportCompensationRequestHistory'),
    MedicalInsuranceRequestHistory: () => import('@/components/employee/employee_requests/MedicalInsuranceRequestHistory'),
    LAndDRequestHistory: () => import('@/components/employee/employee_requests/LAndDRequestHistory'),
    BonusRequestHistory: () => import('@/components/employee/employee_requests/BonusRequestHistory'),
    AbsenceRequestHistory: () => import('@/components/employee/employee_requests/AbsenceRequestHistory'),
    ExpenditureCompensationHistory: () => import('@/components/employee/employee_requests/ExpenditureCompensationRequestHistory.vue'),
    RefundRequestHistory: () => import('@/components/employee/employee_requests/RefundRequestHistory'),
    EquipmentReplacementRequestHistory: () => import('@/components/employee/employee_requests/EquipmentReplacementRequestHistory')
  },
  props: {
    value: {
      required: true,
      default: false
    },
    rowItem: {
      required: false,
      default: null
    },
    selectedColumn: {
      required: true,
      default: null
    },
    tabTitles: {
      required: true,
      type: Array
    },
    headers: {
      required: true,
      type: Array
    },
    requestsInterval: {
      required: true,
      type: Array
    },
    allEmployeeMode: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      currentTabIndex: this.tabTitles.findIndex(el => el.groupName === this.selectedColumn),
      currentTabName: null,
      filterBySubcategory: null,
      groupBy: [],
      requestModels: {
        sportCompensationHistory: false,
        expenditureHistory: false,
        medicalInsuranceHistory: false,
        lAndDHistory: false,
        bonusHistory: false,
        sickLeaveHistory: false,
        refundHistory: false,
        equipmentReplacementHistory: false
      }
    }
  },
  mounted () {
    this.openHistory(this.currentTabIndex)
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    groupByItems () {
      return [
        {
          title: 'Status',
          value: 'Status',
          show: true
        },
        {
          title: 'Employee',
          value: 'Request_Owner',
          show: this.allEmployeeMode
        },
        {
          title: 'Compensation Type',
          value: 'Expenditure_Compensation_Type',
          show: this.currentTabName === 'Benefit'
        }
      ].filter(el => el.show)
    }
  },
  methods: {
    requestWasChanged (group, event) {
      this.$emit('requestWasChanged', { group, ...event })
    },
    openHistory (val) {
      this.groupBy = []
      this.filterBySubcategory = null
      for (const key in this.requestModels) {
        this.requestModels[key] = false
      }
      this.currentTabIndex = val
      this.currentTabName = this.tabTitles[val].groupName
      this.openComponentHistory()
    },
    openComponentHistory () {
      let componentName = ''
      const group = this.headers.find(el => el.groupName === this.currentTabName)

      if (group.subCategoryOf === 'Benefit') {
        this.filterBySubcategory = group.groupName
        componentName = 'Benefit'
      }

      switch (componentName || group.groupName) {
        case 'Benefit':
          this.requestModels.expenditureHistory = true
          break
        case 'L&D':
          this.requestModels.lAndDHistory = true
          break
        case 'Bonus':
          this.requestModels.bonusHistory = true
          break
        case 'Sick Leave':
          this.requestModels.sickLeaveHistory = true
          break
        case 'Sport':
          this.requestModels.sportCompensationHistory = true
          break
        case 'Medical Insurance':
          this.requestModels.medicalInsuranceHistory = true
          break
        case 'Refund':
          this.requestModels.refundHistory = true
          break
        case 'Equipment Update':
          this.requestModels.equipmentReplacementHistory = true
          break
      }
    }
  }
}
</script>
